import React from "react";
import { RadioGroupContext } from "./RadioGroup.context";
import { shortID } from "src/helpers";

interface Props extends React.HTMLProps<HTMLInputElement> {
  name?: string;
  onChange: (value: any) => void;
  defaultValue: any;
}

export const RadioGroup = (props: Props) => {
  const { name, children, onChange, defaultValue } = props;
  const [currentValue, setCurrentValue] = React.useState(defaultValue);
  const [nameState] = React.useState(name ?? shortID());

  const currentContext = {
    name: nameState,
    defaultValue,
    onChange: (value: any) => {
      onChange(value);
      setCurrentValue(value);
    },
    currentValue,
  };

  return (
    <RadioGroupContext.Provider value={currentContext}>
      {children}
    </RadioGroupContext.Provider>
  );
};
